import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { Error404Component } from './modules/error/error-404/error-404.component';
import { PathEnum } from './enums/pathEnum';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    // {path: '', pathMatch : 'full', redirectTo: 'example'},
    // {path: '', pathMatch : 'full', redirectTo: 'home'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    // {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'example'},

    // Auth routes for guests
    {
        path: 'auth',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
        ]
    },

    // Main route - supports either slug or UUID directly after the first slash
    {
        path: ':identifier',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'centered'
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/establishment/establishment.routes')},
            { path: PathEnum.MENU + '/:uuid',
                children: [
                    { path: '', loadChildren: () => import('app/modules/menu/menu.routes')},
                ]
            },
            { path: PathEnum.REVIEW_GAME,
                children: [
                    { path: '', loadChildren: () => import('app/modules/campaign-review/campaign-review.routes')},
                ]
            },
        ]
    },

     // Error routes
     {
        path: PathEnum.ERROR,
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: PathEnum.ERROR_MENU_404, loadChildren: () => import('app/modules/error/error-menu-404/error-menu-404.routes') },
        ]
    },

    
    // // Page not found
    // {
    //     path: '**',
    //     pathMatch : 'full',
    //     component: Error404Component
    // }
];
